module.exports = __webpack_public_path__ + "img/SHIB.f93e7320.svg";